var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDriverOnWay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 144,
  height: 96,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#driver-on-way_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#B0C2E4",
  fillRule: "evenodd",
  d: "M77.436 96c28.862 0 52.401-.636 52.401-1.416s-23.54-1.415-52.4-1.415c-28.862 0-52.402.636-52.402 1.415S48.575 96 77.436 96",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E8F5",
  fillRule: "evenodd",
  d: "M129.719 4.89a2.447 2.447 0 1 1 0-4.893 2.447 2.447 0 0 1 0 4.894M25.859 63.52h-13.07C5.757 63.52.003 69.273.003 76.305c0 7.031 5.754 12.784 12.788 12.784h110.503c11.39 0 20.709-9.316 20.709-20.702s-9.319-20.703-20.709-20.703c-4.815 0-8.755-3.94-8.755-8.754s3.94-8.752 8.755-8.752h10.539c5.006 0 9.103-4.096 9.103-9.101s-4.097-9.1-9.103-9.1h-13.326a3.554 3.554 0 0 1-3.544-3.545 3.553 3.553 0 0 1 3.544-3.542h2.349c1.345 0 2.446-1.1 2.446-2.447a2.454 2.454 0 0 0-2.446-2.445h-15.414c-3.246 0-3.607 3.834-11.808 3.834H76.622a3.2 3.2 0 0 0-3.192 3.192 3.2 3.2 0 0 0 3.192 3.19h3.065a4.64 4.64 0 0 1 4.624 4.624 4.64 4.64 0 0 1-4.624 4.623H70.46c-12.456 0-14.215 3.254-16.398 9.727-2.18 6.472-13.51 6.995-13.51 6.995H25.06c-3.834 0-6.97 3.135-6.97 6.966s3.136 6.968 6.97 6.968h.797c3.687 0 6.703 3.015 6.703 6.701s-3.017 6.701-6.703 6.701z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M122.457 18.02H97.563a1.716 1.716 0 0 1 1.785-1.315 2.64 2.64 0 0 1 3.767-1.284 3.813 3.813 0 0 1 4.66-2.567 5.304 5.304 0 0 1 10.021 1.08q.063-.003.128-.003a3.204 3.204 0 0 1 3.18 2.799 1.72 1.72 0 0 1 1.352 1.288z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D58A7",
  fillRule: "evenodd",
  d: "M84.479 60.695c-13.789 0-25.562 4.708-30.217 11.34l52.337-1.341q2.112.175 4.75-2.178c-5.807-4.717-15.675-7.82-26.87-7.82",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B0C2E4",
  fillRule: "evenodd",
  d: "M80.512 60.827q-.89.06-1.765.145L75.61 71.487l1.735-.044zm-3.42.33-3.094 10.37-7.262.187 2.684-8.993a51 51 0 0 1 7.672-1.563",
  clipRule: "evenodd",
  opacity: 0.06
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6D96CE",
  fillRule: "evenodd",
  d: "M52.164 68.361c-1.751.93-4.049 1.867-6.608 2.175-3.956.475-18.704 3.02-21.024 3.698s-2.893 1.721-2.893 1.94c0 .22-.073 3.552-.073 3.552s-1.467.475-1.831 1.025-.364 1.576-.364 1.576.61 1.146 1.023 2.489c.413 1.344.293 4.797.293 4.797l4.34.764 20.052.812 11.178-.084 42.882-.318 16.589-1.294 3.372-.263 9.084-1.483s1.937-1.188 2.323-2.992c.387-1.804 1.083-4.26 1.083-5.32 0-1.059-1.083-1.71-1.083-1.71l-1.407-7.031c.052-.074.201-.288.389-.575l.143-.221c.246-.385 1.604-2.495.858-2.583-.623-.073-12.641.566-12.641.566s-3.023-1.685-6.961-3.462a83 83 0 0 0-2.881-1.238c-4.294-1.669-8.42-2.638-12.942-3.277a74 74 0 0 0-10.358-.716c-14.242 0-20.422 2.731-32.544 9.175zm54.435 2.332-52.337 1.341c4.656-6.631 16.43-11.34 30.217-11.34 11.195 0 21.061 3.104 26.87 7.82q-2.638 2.353-4.75 2.179",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#223F81",
  fillRule: "evenodd",
  d: "m79.072 90.935 20.067-.15 16.589-1.293 3.372-.263 9.084-1.483s1.937-1.188 2.323-2.992c.387-1.803 1.083-4.26 1.083-5.32 0-1.059-1.083-1.71-1.083-1.71l-1.407-7.031c.052-.073.201-.288.389-.575l.143-.221c.246-.385 1.604-2.494.858-2.583-.543-.063-9.749.415-12.098.538Q93.069 81.217 79.07 90.935z",
  clipRule: "evenodd",
  opacity: 0.13
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC3C3C",
  fillRule: "evenodd",
  d: "m130.494 77.652-1.378-6.892c-2.004 2.264-4.554 5.912-.73 6.676.506.102 1.362.17 2.108.214z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D0D2D3",
  fillRule: "evenodd",
  d: "M21.636 76.33c-.01.644-.061 2.952-.07 3.34.838-.053 2.05-.234 2.564-.568.731-.476 1.574-1.72 1.355-2.16-.186-.37-.387-.562-3.847-.612zM127.086 73.501l2.578.003-.549-2.744c-.711.803-1.49 1.78-2.029 2.741",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D58A7",
  fillRule: "evenodd",
  d: "M69.054 60.95c-.103.308-.23.543-.369.614-6 3.06-10.126 4.29-15.162 8.825-.628.565-4.669.42-5.181-.44 1.44-.43 2.736-1.01 3.823-1.586 6.648-3.533 11.507-5.949 16.889-7.412M103.421 61.65a257 257 0 0 1 7.396 3.418c3.42 1.663 5.885 3.21 5.957 3.206.3-.017.713-.2 1.073-.394a102 102 0 0 0-6.96-3.461 84 84 0 0 0-2.881-1.239 51 51 0 0 0-4.586-1.53z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#06162A",
  fillRule: "evenodd",
  d: "M44.772 86.26c-.673-4.824-4.816-8.537-9.825-8.537-5.31 0-9.645 4.168-9.91 9.41-.006.114-.122 2.058-.4 3.175l.388.07 20.053.81.212-.002c-.424-1.864-.494-4.749-.518-4.926M109.151 78.053c-5.118 0-9.332 3.876-9.865 8.852q-.04.39-.053.789a18.5 18.5 0 0 1-.374 3.094l.279-.002 16.588-1.294 3.373-.263.268-.043c-.201-.722-.309-1.736-.314-1.822a9.92 9.92 0 0 0-9.903-9.311z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8FA3CF",
  fillRule: "evenodd",
  d: "M28.788 86.841a5.938 5.938 0 1 1 10.23 4.103 5.92 5.92 0 0 1-4.294 1.834c-1.86 0-3.52-.855-4.61-2.194a5.9 5.9 0 0 1-1.328-3.743zM39.5 90.962a6.305 6.305 0 0 0-4.773-10.426A6.305 6.305 0 1 0 39.5 90.962",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M34.727 92.778c3.27 0 5.938-2.667 5.938-5.936s-2.667-5.937-5.938-5.937-5.938 2.667-5.938 5.937 2.668 5.936 5.938 5.936",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E4E5E5",
  fillRule: "evenodd",
  d: "M36.868 92.38a5.937 5.937 0 0 1-8.079-5.538c0-3.279 2.51-5.786 5.661-5.93a5.937 5.937 0 0 0 2.416 11.469z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CAC9CA",
  fillRule: "evenodd",
  d: "M34.727 87.434a.594.594 0 0 0 .593-.593.595.595 0 0 0-.593-.593.596.596 0 0 0-.594.593c0 .326.267.593.594.593",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5E5F5F",
  fillRule: "evenodd",
  d: "m34.9 83.901.322-.861.335-.892c.253-.724-1.88-.76-1.576.03l.322.862.335.892c.14.35.24.035.264-.03zM36.347 84.382l.709-.585.735-.605c.582-.5-1.247-1.596-1.38-.76l-.153.906-.157.94c-.053.373.19.15.244.105zM37.36 85.521l.907-.15.94-.158c.753-.143-.282-2.007-.815-1.35l-.585.71-.606.735c-.234.296.09.225.16.213M37.668 87.014l.86.322.892.333c.724.254.76-1.878-.03-1.575l-.862.322-.892.333c-.352.14-.036.24.03.265zM37.186 88.46l.584.71.606.735c.5.58 1.598-1.247.761-1.38l-.906-.151-.94-.157c-.374-.054-.15.19-.105.245zM36.047 89.472l.152.907.157.94c.143.753 2.007-.282 1.349-.815l-.71-.585-.735-.605c-.296-.234-.224.09-.213.16zM34.553 89.78l-.322.861-.335.892c-.254.724 1.88.76 1.577-.03l-.322-.862-.335-.892c-.14-.35-.239-.035-.264.031M33.108 89.3l-.71.584-.735.605c-.582.5 1.247 1.598 1.38.761l.153-.906.157-.94c.053-.374-.19-.15-.244-.105zM32.093 88.161l-.907.15-.94.157c-.754.143.282 2.007.816 1.35l.585-.71.606-.735c.234-.297-.09-.226-.16-.213zM31.785 86.668l-.86-.323-.892-.333c-.724-.253-.76 1.88.03 1.577l.862-.322.892-.335c.35-.14.035-.24-.032-.264M32.266 85.22l-.584-.709-.607-.735c-.5-.582-1.596 1.247-.76 1.38l.906.153.94.156c.373.054.15-.19.105-.245M33.406 84.21l-.152-.907-.157-.94c-.144-.753-2.007.282-1.35.816l.71.584.735.605c.297.235.226-.089.214-.159",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D0D2D3",
  fillRule: "evenodd",
  d: "M33.877 85.845a.421.421 0 1 0 0-.843.421.421 0 0 0 0 .843M35.896 85.186a.423.423 0 0 1-.73.422.422.422 0 0 1 .73-.422M36.746 87.025a.422.422 0 1 1-.73-.423.422.422 0 0 1 .73.423M35.576 88.68a.421.421 0 1 1 0-.842.421.421 0 0 1 0 .843M33.558 88.495a.423.423 0 0 1 .73-.421.422.422 0 0 1-.73.421M32.709 86.656a.422.422 0 1 1 .73.424.422.422 0 0 1-.73-.424",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0E2952",
  fillRule: "evenodd",
  d: "M39.5 90.962a6.3 6.3 0 0 1-4.773 2.185 6.3 6.3 0 0 1-5.09-2.583 6.305 6.305 0 0 1 5.09-10.028A6.305 6.305 0 0 1 39.5 90.962m-12.409-.5a8.45 8.45 0 0 0 7.636 4.826 8.447 8.447 0 1 0 0-16.894 8.448 8.448 0 0 0-7.636 12.067M113.798 90.962a6.3 6.3 0 0 1-4.773 2.185 6.3 6.3 0 0 1-5.09-2.583 6.305 6.305 0 0 1 5.09-10.028 6.305 6.305 0 0 1 4.773 10.426m-12.408-.5a8.45 8.45 0 0 0 7.636 4.826 8.448 8.448 0 1 0 0-16.894 8.448 8.448 0 0 0-7.636 12.067",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D58A7",
  d: "M40.496 75.085a.174.174 0 0 1-.004-.348l86.719-2.022h.005c.094 0 .171.076.174.17a.174.174 0 0 1-.17.178l-86.719 2.022h-.005"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1C4689",
  fillRule: "evenodd",
  d: "M82.362 73.168q-3.112 1.263-.604 1.08 5.037.1 5.329.038.75-.918-.056-1.026-2.929-.312-4.67-.092",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D58A7",
  d: "M44.093 81.2a.175.175 0 0 1-.175-.171.175.175 0 0 1 .172-.178l57.868-1.17c.093-.01.177.074.178.17a.175.175 0 0 1-.17.178l-57.87 1.172zM44.35 81.922a.174.174 0 0 1-.004-.35l57.283-1.16c.096-.012.175.075.178.172a.175.175 0 0 1-.172.177l-57.282 1.16zM114.903 79.386a.175.175 0 0 1-.174-.165.175.175 0 0 1 .165-.183l15.17-.749c.091-.025.178.069.183.166a.175.175 0 0 1-.166.182l-15.17.749h-.009zM117.25 80.475a.175.175 0 0 1-.174-.165.175.175 0 0 1 .166-.183l13.596-.67c.093-.022.178.069.183.166a.175.175 0 0 1-.165.182l-13.597.67z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D58A7",
  d: "M54.352 91.157a.12.12 0 0 1-.103-.056c-1.713-2.624-2.57-6.081-2.622-10.566.01-4.165.869-7.056 2.554-8.592a.125.125 0 0 1 .174.007.124.124 0 0 1-.009.174c-1.63 1.489-2.464 4.318-2.474 8.41.05 4.435.896 7.847 2.583 10.432a.124.124 0 0 1-.103.191"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#223F81",
  d: "M82.86 90.987a.13.13 0 0 1-.085-.03.14.14 0 0 1-.026-.194c4.78-6.191 6.403-12.59 4.96-19.561a.139.139 0 0 1 .272-.056c1.461 7.056-.178 13.529-5.011 19.787a.14.14 0 0 1-.11.054"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9DB2D9",
  fillRule: "evenodd",
  d: "m90.075 60.96-.321-.03-2.092 10.248.308-.007.022-.001z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8FA3CF",
  fillRule: "evenodd",
  d: "M103.086 86.841a5.938 5.938 0 1 1 10.229 4.103 5.92 5.92 0 0 1-4.293 1.834c-1.86 0-3.52-.855-4.609-2.194a5.9 5.9 0 0 1-1.329-3.743zm10.71 4.121a6.306 6.306 0 0 0-4.772-10.426 6.305 6.305 0 1 0 4.772 10.426",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M109.024 92.778c3.27 0 5.938-2.667 5.938-5.936s-2.668-5.937-5.938-5.937-5.938 2.667-5.938 5.937 2.668 5.936 5.938 5.936",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E4E5E5",
  fillRule: "evenodd",
  d: "M111.165 92.38a5.937 5.937 0 0 1-8.079-5.538c0-3.279 2.511-5.786 5.661-5.93a5.94 5.94 0 0 0-3.799 5.537 5.937 5.937 0 0 0 6.217 5.93",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CAC9CA",
  fillRule: "evenodd",
  d: "M109.024 87.434a.594.594 0 0 0 .593-.593.595.595 0 0 0-.593-.593.596.596 0 0 0-.594.593c0 .326.267.593.594.593",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5E5F5F",
  fillRule: "evenodd",
  d: "m109.198 83.901.322-.861.335-.892c.253-.724-1.88-.76-1.577.03l.322.862.334.892c.14.35.24.035.265-.03zM110.645 84.382l.71-.585.735-.605c.582-.5-1.249-1.596-1.381-.76l-.152.906-.157.94c-.054.373.19.15.244.105zM111.658 85.521l.907-.15.94-.158c.754-.143-.282-2.007-.816-1.35l-.585.71-.606.735c-.234.296.089.225.159.213zM111.966 87.014l.86.322.892.333c.724.254.76-1.878-.031-1.575l-.861.322-.892.333c-.351.14-.034.24.032.265M111.486 88.46l.585.71.606.735c.5.58 1.597-1.247.761-1.38l-.907-.151-.939-.157c-.374-.054-.151.19-.105.245zM110.344 89.472l.152.907.157.94c.143.753 2.007-.282 1.349-.815l-.709-.585-.735-.605c-.297-.234-.226.09-.214.16zM108.852 89.78l-.323.861-.334.892c-.254.724 1.88.76 1.577-.03l-.322-.862-.334-.892c-.139-.35-.24-.035-.264.031M107.404 89.3l-.709.584-.735.605c-.582.5 1.248 1.598 1.381.761l.152-.906.156-.94c.054-.374-.19-.15-.243-.105zM106.391 88.161l-.906.15-.94.157c-.754.143.282 2.007.815 1.35l.584-.71.607-.735c.234-.297-.09-.226-.16-.213zM106.084 86.668l-.86-.323-.892-.333c-.724-.253-.76 1.88.031 1.577l.861-.322.892-.335c.351-.14.034-.24-.032-.264M106.564 85.22l-.585-.709-.606-.735c-.5-.582-1.598 1.247-.761 1.38l.906.153.94.156c.374.054.151-.19.106-.245M107.704 84.21l-.152-.907-.156-.94c-.144-.753-2.008.282-1.35.816l.71.584.735.605c.297.235.226-.089.213-.159",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D0D2D3",
  fillRule: "evenodd",
  d: "M108.175 85.845a.422.422 0 1 0 0-.844.422.422 0 0 0 0 .843M110.193 85.186a.421.421 0 1 1-.73.422.421.421 0 0 1 .73-.422M111.043 87.025a.422.422 0 1 1-.73-.424.422.422 0 0 1 .73.424M109.875 88.68a.422.422 0 1 1 0-.843.422.422 0 0 1 0 .843M107.855 88.495a.423.423 0 0 1 .731-.421c.116.2.046.458-.155.576a.423.423 0 0 1-.576-.155M107.008 86.656a.42.42 0 0 1 .575-.153.42.42 0 1 1-.421.729.42.42 0 0 1-.154-.576",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#223F81",
  fillRule: "evenodd",
  d: "m27.61 80.963-7.016 4.98c.164 1.562.092 3.669.092 3.669l3.951.696c.279-1.118.395-3.063.401-3.176a9.9 9.9 0 0 1 2.572-6.17z",
  clipRule: "evenodd",
  opacity: 0.13
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D58A7",
  fillRule: "evenodd",
  d: "M53.571 72.188c4.232.658 5.316-2.422 3.345-2.552-.357-.024-.774.003-1.246.036a22 22 0 0 0-.654.058q-.98.187-1.828 2.195-.005.192.383.262z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B0C2E4",
  fillRule: "evenodd",
  d: "M53.733 72.26c3.916.609 5.137-1.982 3.735-2.476 1.135.631-.141 2.99-3.896 2.405a1 1 0 0 1-.13-.03.7.7 0 0 0 .291.1",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F9AF79",
  fillRule: "evenodd",
  d: "M83.773 64.71s-1.514.77-1.622.936c-.11.165-.2 1.05-.08 1.269.122.218.764.4.939.337.176-.062.1-.472.23-.619.131-.145.277-.22.39-.3.215-.148.59-.516.59-.516l-.446-1.107z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#223F81",
  fillRule: "evenodd",
  d: "M88.244 54.549s-.06 6.393-.802 7.152c-.741.758-3.671 3.009-3.671 3.009l.466 1.298s3.388-1.157 4.884-2.245c1.497-1.09 3.02-3.695 3.02-3.695l-3.896-5.52z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#172B57",
  fillRule: "evenodd",
  d: "m92.44 49.651-2.167 4.114-.519.037-.234.655-2.172 6.548s-1.203-8.32 5.093-11.354",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#20386F",
  fillRule: "evenodd",
  d: "M88.823 53.287s-2.4 8.839-2.63 17.272c0 0 1.988.693 5.114.144 3.14-.551-2.485-17.415-2.485-17.415z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0E2952",
  fillRule: "evenodd",
  d: "M99.755 95.287h2.155c.272-.147.514-.485.59-.988.105-.694.883-1.073 1.051-1.641.169-.567-.695-1.367-.695-1.367l-.144-.186-.15-.194-1.431.337s-.036.34-.058.775a10 10 0 0 0-.007.993c.043.757-.211 1.573-.884 1.72-.497.109-.475.404-.43.55zM87.242 95.287h4.931c.236-.29.15-1.358.114-1.706-.007-.07-.014-.111-.014-.111s-1.683-1.346-1.915-.316a1 1 0 0 1-.024.095c-.29.965-1.598 1.403-2.352 1.524-.491.08-.671.335-.74.512z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#223F81",
  fillRule: "evenodd",
  d: "M88.182 67.774s.256 3.189.557 7.022c.408 5.206.9 11.602.949 12.814.084 2.103.42 5.47.42 5.47s.799.8 2.398.461c0 0 1.425-4.803 1.833-9.887q.01-.124.018-.25c.38-5.175.969-16.072.969-16.072l-7.143.441z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#20386F",
  fillRule: "evenodd",
  d: "M88.182 67.774s.256 3.189.557 7.022l5.6 8.858q.01-.124.018-.25c.38-5.175.969-16.072.969-16.072l-7.143.441z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#223F81",
  fillRule: "evenodd",
  d: "M89.35 68.153s4.607 11.548 7.637 16.975c3.029 5.426 3.978 6.94 3.978 6.94s1.735-.692 1.892-1.166c0 0-1.158-10.477-3.187-13.031-1.147-1.443-2.494-5.774-2.556-7.289-.064-1.514-.411-4.512-.411-4.512z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F9AF79",
  fillRule: "evenodd",
  d: "M90.498 51.318c1.8.569 4.915-.965 4.915-.965s-1.66-1.246-1.572-3.835l-1.393 1.122-.946.762s.005.448.107 1.236q.029.216.067.464a.34.34 0 0 1-.151.336c-.656.405-1.027.88-1.027.88",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M87.983 68.04a.3.3 0 0 0 .19.072c.677-.01 2.648.367 4.316.195 1.407-.135 2.652-.551 3.99-1.15.177-.08.584-.298.576-.496a25 25 0 0 0-.056-.929c-.094-1.38-.258-3.752-.099-6.49q.044-.765.047-1.513c.014-3.71-.722-6.974-2.201-8.078 0 0-1.03.579-1.745.806-.7.225-1.06.18-1.422-.062 0 0-.706.351-1.008.68-.7.762-1.245 1.772-1.605 3.224-.306 1.235-.593 3.036-.694 5.342-.044 1.047-.334 8.364-.289 8.4",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#20386F",
  fillRule: "evenodd",
  d: "M98.23 69.76c-4.545 2.85-8.252 1.404-8.252 1.404-.665-5.199-.297-11.47-.21-13.002.22-6.717 4.978-8.512 4.978-8.512l1.981 6.13.294 2.728.53 4.928z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC3C3C",
  fillRule: "evenodd",
  d: "M91.502 48.402s.005.448.108 1.236c1.047-.18 2.236-1.873 2.236-1.873-.533-.153-1-.181-1.398-.125z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F9AF79",
  fillRule: "evenodd",
  d: "M90.434 48.859s3.63.604 3.97-1.664c.342-2.266 1.04-3.715-1.264-4.197-2.303-.481-2.887.316-3.183 1.045-.298.729-.46 4.6.477 4.814z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#20386F",
  fillRule: "evenodd",
  d: "M94.48 47.008c.114.104-.444-.092-.384-.606.06-.513.059-1.183-.358-1.058-.416.125-.438.46-.61.265s-.174-1.017-1.415-1.075c-1.243-.057-1.985.202-2.562-.051-.578-.254-1.16-1.202-1.16-1.202s.715.387.965.486c0 0-.726-1.145.39-2.048 1.115-.904 2.252-.312 2.897-.273 1.422.086 3.582.784 4.045 1.717.466.935-1.236 2.304-1.806 3.846z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F9AF79",
  fillRule: "evenodd",
  d: "M100.465 66.55s-.335.35-.356.495c-.069.466-.224.666-.146.717.163.106.379-.24.48-.549.103-.31.022-.662.022-.662",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#20386F",
  fillRule: "evenodd",
  d: "M97.55 63.435c-.996-2.548-3.778-6.845-3.778-6.845l3.25 1.918z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#223F81",
  fillRule: "evenodd",
  d: "M100.801 66.353c-.56.11-1.166.065-1.166.065s-1.66-5.125-1.874-5.594c-.137-.302-2.256-2.455-3.736-3.943a3.16 3.16 0 0 1-.726-3.333l1.445-3.897s1.123.657 2.309 2.703c1.465 2.528 3.077 6.599 3.363 7.26.856 1.979 1.153 6.413 1.153 6.413s-.331.242-.768.328z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0E2952",
  fillRule: "evenodd",
  d: "m94.746 49.651-2.169 4.114-1.112-.404.362 1.097-2.175 6.548s-1.202-8.319 5.094-11.353z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#20386F",
  fillRule: "evenodd",
  d: "M91.618 46.308c.132.016.296-.49-.024-.53-.172-.02-.191.503.024.53M90.119 46.1c-.132-.017-.176-.547.144-.508.17.02.071.534-.145.507M91.534 45.306c-.213-.018-.227.158-.077.224.043.02.884.295.852.238-.06-.12-.372-.426-.775-.46zM90.518 45.105c.214.025.195.2.036.236-.075.015-.931.12-.871.052a1.1 1.1 0 0 1 .835-.288",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC3C3C",
  fillRule: "evenodd",
  d: "M90.09 46.942c.4.29.422.066.287.044-.446-.071.04-.165.238-.913.02-.078-.069-.1-.093-.038-.017.043-.062.209-.085.254-.267.556-.475.56-.348.653z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M90.226 47.392c.619 1.185 1.284.123 1.1.09-.935-.158-1.176-.234-1.1-.09",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F9AF79",
  fillRule: "evenodd",
  d: "M100.193 66.422c.047.087.082.17.086.225.094 1.255-.479 1.428 1.005 2.125 0 0 .633.241.644-.25s-.439-.5-.357-1.188c.087-.732.087-.797-.323-1.125a2 2 0 0 1-.446.146c-.208.04-.422.06-.609.068",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m39.592 55.765 3.573.635c1.62.384-3.371.528-3.577.552l-.422 5.387c-.255 2.442-.35-5.084-.366-5.393l-3.573-.636c-1.619-.384 3.37-.528 3.577-.552l.421-5.387c.254-2.443.35 5.082.365 5.393zM109.032 40.798l3.573.636c1.62.383-3.371.527-3.577.55l-.421 5.388c-.254 2.442-.349-5.084-.365-5.393l-3.573-.636c-1.62-.384 3.371-.528 3.576-.552l.422-5.387c.255-2.443.35 5.084.366 5.394zM130.234 66.924l2.344.417c1.062.25-2.212.346-2.347.361l-.276 3.535c-.166 1.603-.229-3.335-.24-3.539l-2.345-.416c-1.062-.251 2.212-.347 2.348-.363l.277-3.535c.166-1.602.229 3.335.24 3.539zM47.75 69.85l1.608.285c.73.173-1.517.238-1.609.249l-.19 2.424c-.113 1.1-.158-2.287-.164-2.426l-1.607-.286c-.728-.173 1.517-.237 1.61-.249l.188-2.424c.114-1.099.158 2.287.165 2.427",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E8F5",
  fillRule: "evenodd",
  d: "M54.476 9.525H29.582a1.716 1.716 0 0 1 1.785-1.315 2.64 2.64 0 0 1 3.767-1.284 3.814 3.814 0 0 1 4.66-2.567 5.306 5.306 0 0 1 10.022 1.08q.064-.003.129-.004a3.205 3.205 0 0 1 3.18 2.8 1.72 1.72 0 0 1 1.351 1.288zM19.368 28.038h33.826a2.33 2.33 0 0 0-2.425-1.786 3.586 3.586 0 0 0-5.12-1.744 5.18 5.18 0 0 0-6.332-3.489 7.208 7.208 0 0 0-13.616 1.468l-.175-.005a4.36 4.36 0 0 0-4.322 3.803 2.33 2.33 0 0 0-1.837 1.752z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M70.783 52.145H45.889a1.716 1.716 0 0 1 1.669-1.32q.059.001.116.005a2.637 2.637 0 0 1 3.768-1.284 3.814 3.814 0 0 1 4.66-2.567 5.305 5.305 0 0 1 10.021 1.08l.129-.003a3.21 3.21 0 0 1 3.18 2.799 1.72 1.72 0 0 1 1.352 1.288zM19.876 80.542l1.608.286c.729.172-1.517.237-1.61.248l-.19 2.425c-.113 1.099-.157-2.287-.163-2.427l-1.608-.285c-.73-.173 1.517-.238 1.609-.25l.19-2.424c.114-1.098.158 2.288.164 2.427M121.859 24.431l2.344.417c1.063.251-2.211.347-2.346.363l-.276 3.535c-.166 1.602-.229-3.336-.24-3.54l-2.344-.416c-1.062-.25 2.212-.346 2.346-.361l.276-3.535c.167-1.603.229 3.335.24 3.539z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "driver-on-way_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h144v96H0z"
})))));
export default SvgDriverOnWay;